import { gql } from "graphql-request";

export const CREATE_SHIPPING_ADDRESS = gql`
mutation CreateShippingAddress(
  $userId: ID!,
  $addressLine1: String!,
  $addressLine2: String,
  $city: String!,
  $country: String!,
  $firstName: String!,
  $lastName: String!,
  $postcode: String!,
  $province: String,
  $telephone: String!,
  $phoneCode: String,
  $emoji: String,
  $useAddressForBilling: Boolean!
) {
  createShippingAddress(
    data: {
      addressLine1: $addressLine1,
      addressLine2: $addressLine2,
      city: $city,
      country: $country,
      firstName: $firstName,
      lastName: $lastName,
      postcode: $postcode,
      province: $province,
      telephone: $telephone,
      phoneCode: $phoneCode,
      emoji: $emoji,
      useAddressForBilling: $useAddressForBilling,
      user: { connect: { id: $userId } }  # Связываем с текущим пользователем
    }
  ) {
    id
    addressLine1
    addressLine2
    city
    country
    firstName
    lastName
    postcode
    province
    telephone
    phoneCode
    emoji
    useAddressForBilling
    user {
      id
    }
  }
}
`;

export const REGISTER = gql`
  mutation Register($data: UserCreateInput!) {
    createUser(data: $data) {
      id
      name
      email
    }
  }
`;

export const RECORD_PRODUCT_VIEW = gql`
  mutation RecordProductView($productId: ID!) {
    recordProductView(productId: $productId)
  }
`;


export const LOGIN = gql`
mutation login ($email: String!, $password: String!) {
  authenticateUserWithPassword(email: $email, password: $password) {
    ... on UserAuthenticationWithPasswordSuccess {
      item {
        id
        email
        name
        isAdmin
        avatar {
          id
          publicUrl
          originalFilename
        }
      }
    }
  }
}
`;

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($data: ProductCreateInput!) {
    createProduct(data: $data) {
      id
      title
      materialPrices {
        id
        materialName
        price
        sizes {
          id
        }
        variantInventories {
          id
          stockQuantity
          isAvailable
          product {
            id
          }
          size {
            id
            label
            value
          }
        }
      }
    }
  }
`;

export const CREATE_PRODUCT_VARIANT_INVENTORY = gql`
  mutation CreateProductVariantInventory($data: ProductVariantInventoryCreateInput!) {
    createProductVariantInventory(data: $data) {
      id
      stockQuantity
      isAvailable
      product {
        id
      }
      size {
        id
        label
        value
      }
    }
  }
`;

export const UPDATE_MATERIAL_PRICE_STOCK = gql`
  mutation UpdateMaterialPriceStock($id: ID!, $stockQuantity: Int!) {
    updateMaterialPrice(
      where: { id: $id }
      data: { stockQuantity: $stockQuantity }
    ) {
      id
      stockQuantity
    }
  }
`;

export const UPDATE_PRODUCT_VARIANT_INVENTORY_STOCK = gql`
  mutation UpdateProductVariantInventoryStock($id: ID!, $stockQuantity: Int!) {
    updateProductVariantInventory(
      where: { id: $id }
      data: { stockQuantity: $stockQuantity }
    ) {
      id
      stockQuantity
    }
  }
`;

export const UPDATE_PRODUCT_VARIANT_INVENTORY_AVAILABILITY = gql`
  mutation UpdateProductVariantInventoryAvailability($id: ID!, $isAvailable: Boolean!) {
    updateProductVariantInventory(
      where: { id: $id }
      data: { isAvailable: $isAvailable }
    ) {
      id
      isAvailable
    }
  }
`;

export const UPDATE_MATERIAL_PRICE_PRICE = gql`
  mutation UpdateMaterialPricePrice($id: ID!, $price: Int!) {
    updateMaterialPrice(
      where: { id: $id }
      data: { price: $price }
    ) {
      id
      price
    }
  }
`;

export const UPDATE_MATERIAL_PRICE_AVAILABILITY = gql`
  mutation UpdateMaterialPriceAvailability($id: ID!, $isAvailable: Boolean!) {
    updateMaterialPrice(
      where: { id: $id }
      data: { isAvailable: $isAvailable }
    ) {
      id
      isAvailable
    }
  }
`;

export const UPDATE_MATERIAL_PRICE_SIZES = gql`
  mutation UpdateMaterialPriceSizes($id: ID!, $sizeIds: [SizeWhereUniqueInput!]!) {
    updateMaterialPrice(
      where: { id: $id }
      data: { sizes: { set: $sizeIds } }
    ) {
      id
      sizes {
        id
        label
        value
        gender
        productType
      }
    }
  }
`;

export const UPDATE_USER_ADMIN_STATUS = gql`
  mutation UpdateUserAdminStatus($id: ID!, $isAdmin: Boolean!) {
    updateUser(where: { id: $id }, data: { isAdmin: $isAdmin }) {
      id
      name
      email
      isAdmin
    }
  }
`;

export const DELETE_PRODUCT_CASCADE = gql`
  mutation DeleteProductCascade($productId: ID!) {
    deleteProductCascade(productId: $productId)
  }
`;

export const CREATE_PRODUCT_IMAGE = gql`
  mutation CreateProductImage($data: ProductImageCreateInput!) {
    createProductImage(data: $data) {
      id
      image {
        publicUrl
          mimetype
          originalFilename
      }
      material {
        id
        materialName
      }
      product {
        id
      }
    }
  }
`;

export const CREATE_PRODUCT_ANIMATION = gql`
  mutation CreateProductAnimation($productId: ID!, $materialPriceId: ID!, $file: Upload!) {
    createProductAnimation(
      productId: $productId
      materialPriceId: $materialPriceId
      file: $file
    ) {
      id
      publicUrl
          mimetype
          originalFilename
      mimetype
    }
  }
`;

export const DELETE_PRODUCT_IMAGE = gql`
  mutation DeleteProductImage($id: ID!) {
    deleteProductImage(where: { id: $id }) {
      id
    }
  }
`;

export const LOGOUT = gql`
 mutation Mutation {
  endSession
}
`

export const LIKED_PRODUCT = gql`
mutation ConnectProductToUser($productId: ID!, $userId: ID!) {
    updateUser(
      where: { id: $userId }
      data: {
        products: { connect: [{ id: $productId }] }
      }
    ) {
      id
      name
      products {
        id
        title
      }
    }
  }
  `;

  export const REMOVE_LIKE_FROM_PRODUCT = gql`
  mutation DisconnectProductFromUser($productId: ID!, $userId: ID!) {
    updateUser(
      where: { id: $userId }
      data: {
        products: { disconnect: [{ id: $productId }] }
      }
    ) {
      id
      name
      products {
        id
        title
      }
    }
  }
  `;

  export const CREATE_CART_ITEM = gql`
  mutation CreateCartItem(
    $userId: ID!,
    $productId: ID!,
    $selectedSize: String,
    $selectedMaterial: String!,
    $price: Float!
  ) {
    createCartItem(data: {
      user: { connect: { id: $userId } }
      product: { connect: { id: $productId } }
      selectedMaterial: $selectedMaterial
      selectedSize: $selectedSize
      price: $price
    }) {
      id
      user {
        name
      }
      selectedSize
      selectedMaterial
      price
    }
  }
  `;

  export const UPDATE_CART_ITEM = gql`
  mutation UpdateCartItem($id: ID!, $size: String!, $material: String!) {
    updateCartItem(
      where: { id: $id }
      data: { selectedSize: $size, selectedMaterial: $material }
    ) {
      id
      selectedSize
      selectedMaterial
    }
  }
`;

export const DELETE_CART_ITEM = gql `
mutation DeleteCartItem($where: CartItemWhereUniqueInput!) {
  deleteCartItem(where: $where) {
    id
  }
}
`

export const UPDATE_CART_ITEM_QUANTITY = gql `
mutation UpdateCartItems($data: [CartItemUpdateArgs!]!) {
  updateCartItems(data: $data) {
    id
    quantity
  }
}
`

export const CREATE_PAYD_ORDER = gql`
mutation CreatePaydOrder(
  $userId: ID!,
  $totalAmount: Int!,
  $items: [PaydOrderItemCreateInput!]!
) {
  createPaydOrder(
    data: {
      user: { connect: { id: $userId } }
      totalAmount: $totalAmount
      items: { create: $items }
    }
  ) {
    id
    user {
      name
    }
    totalAmount
    paymentDate
    items {
      id
      product {
        id
        title
      }
      size
      material
      quantity
    }
  }
}
`;

export const DELETE_ALL_CART_ITEM = gql`
  mutation DeleteCartItem($where: CartItemWhereUniqueInput!) {
    deleteCartItem(where: $where) {
      id
    }
  }
`;

export const CREATE_PAYMENT_INTENT = gql`
  mutation CreatePaymentIntent($input: PaymentIntentInput) {
    createPaymentIntent(input: $input) {
      clientSecret
      paymentIntentId
    }
  }
`;

export const FINALIZE_PAYMENT_INTENT_ORDER = gql`
  mutation FinalizePaymentIntentOrder($paymentIntentId: String!) {
    finalizePaymentIntentOrder(paymentIntentId: $paymentIntentId) {
      success
    }
  }
`;

export const CREATE_PAYPAL_ORDER = gql`
  mutation CreatePayPalOrder(
    $shippingAddress: ZipTaxAddressInput
    $guestEmail: String
    $guestCartItems: [GuestCartItemInput!]
  ) {
    createPayPalOrder(
      shippingAddress: $shippingAddress
      guestEmail: $guestEmail
      guestCartItems: $guestCartItems
    ) {
      orderId
    }
  }
`;

export const CAPTURE_PAYPAL_ORDER = gql`
  mutation CapturePayPalOrder($orderId: String!) {
    capturePayPalOrder(orderId: $orderId) {
      success
    }
  }
`;

export const CREATE_COMMENT = gql`
  mutation CreateComment($userId: ID!, $productId: ID!) {
    createComment(data: {
      author: { connect: { id: $userId } },
      product: { connect: { id: $productId } }
    }) {
      id
    }
  }
`;

export const CREATE_COMMENT_ITEM = gql`
  mutation CreateCommentItem($data: CommentItemCreateInput!) {
    createCommentItem(data: $data) {
      id
      content
      createdAt
      parent {
        id
      }
      images {
        id
        image {
          id
          publicUrl
          mimetype
          originalFilename
        }
      }
      author {
        id
        name
      }
      comment {
        id
      }
    }
  }
`;

export const CREATE_COMMENT_IMAGE = gql`
  mutation CreateCommentImage($data: CommentImageCreateInput!) {
    createCommentImage(data: $data) {
      id
      image {
        id
        publicUrl
        mimetype
        originalFilename
      }
      commentItem {
        id
      }
      author {
        id
      }
    }
  }
`;

export const RESET_PASSWORD_EMAIL = gql`
mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(email: $email)
}
`;

export const RESET_PASSWORD_BY_TOKEN = gql`
mutation ResetPassword($token: String!, $newPassword: String!, $email: String!) {
  resetPassword(token: $token, newPassword: $newPassword, email: $email)
}
`;

export const UPDATE_PRODUCT_SIZE = gql`
mutation UpdateProductSize($where: ProductWhereUniqueInput!, $data: ProductUpdateInput!) {
  updateProduct(where: $where, data: $data) {
    selectedSize
  }
}
`
export const UPDATE_PRODUCT_MATERIAL = gql`
mutation UpdateProductMaterial($where: ProductWhereUniqueInput!, $data: ProductUpdateInput!) {
  updateProduct(where: $where, data: $data) {
    selectedMaterial
  }
}
`

export const SAVE_PRODUCT_SELECTION = gql`
mutation SaveProductSelection(
  $productId: ID!
  $selectedMaterial: String!
  $selectedSize: String
  $clientId: String
) {
  saveProductSelectionState(
    productId: $productId
    selectedMaterial: $selectedMaterial
    selectedSize: $selectedSize
    clientId: $clientId
  ) {
    id
    selectedMaterial
    selectedSize
  }
}
`;

export const  UPDATE_CART_ITEM_SIZE = gql`
  mutation UpdateCartItemSize($cartItemId: ID!, $newSize: String!) {
    updateCartItem(where: { id: $cartItemId }, data: { selectedSize: $newSize}) {
      id
        selectedSize
    }
  }
`

export const UPDATE_CART_ITEM_MATERIAL = gql`
  mutation UpdateCartItemMaterial($cartItemId: ID!, $selectedMaterial: String!, $selectedSize: String) {
    updateCartItem(where: { id: $cartItemId }, data: { selectedMaterial: $selectedMaterial, selectedSize: $selectedSize }) {
      id
      selectedMaterial
      selectedSize
    }
  }
`

export const UPDATE_SHIP_ADRESS_CHECK_BOX = gql`
mutation UpdateShippingAddressCheckBox($where: ShippingAddressWhereUniqueInput!, $data: ShippingAddressUpdateInput!) {
  updateShippingAddress(where: $where, data: $data) {
    id
    useAddressForBilling
  }
}
` 

export const UPDATE_SHIP_ADRESS = gql`
mutation UpdateShippingAddress($where: ShippingAddressWhereUniqueInput!, $data: ShippingAddressUpdateInput!) {
  updateShippingAddress(where: $where, data: $data) {
    firstName
    lastName
    addressLine1
    addressLine2
    city
    postcode
    telephone
    phoneCode
    emoji
    country
    province
  }
}
` 

export const DELETE_SHIPPING_ADDRESS = gql`
mutation DeleteShippingAddress($where: ShippingAddressWhereUniqueInput!) {
  deleteShippingAddress(where: $where) {
    id
  }
}
`

export const UPDATE_EMAIL_PREFERENCE = gql`
mutation UpdateEmailPreference($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
  updateUser(where: $where, data: $data) {
    id
    marketingEmailsOptIn
  }
}
`

export const UPDATE_USER_AVATAR = gql`
  mutation UpdateUserAvatar($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
    updateUser(where: $where, data: $data) {
      id
      avatar {
        id
        publicUrl
        originalFilename
      }
    }
  }
`;

export const SUBSCRIBE_MARKETING_EMAIL = gql`
mutation SubscribeMarketingEmail($email: String!) {
  subscribeMarketingEmail(email: $email)
}
`
